import storageWrapper from './StorageWrapper';
import { getCompatibleStorage } from './utils';

export { storage as localStorage } from './localStorageWrapper';

const storage = storageWrapper(getCompatibleStorage);

export default storage;
